export default "__VITE_ASSET__CgHvx7p2__"